const inputMixin = {
    data() {
        return {
        }
    },
    methods: {
        isNumber: function(evt) {
            if (evt.charCode >= 48 && evt.charCode <= 57) {
                return true; 
            } else {
                evt.preventDefault()
            }
        }
    }
}